<script setup lang="ts">
const props = defineProps({
  url: String,
  urlMatch: { type: [String, RegExp], required: false },
  icon: String,
  iconAlt: String,
  badge: [String, Number],
  label: String,
  active: Boolean,
  routerLink: Boolean,
  v2Link: { type: Boolean, default: false },
})

const isHovered = ref(false)
const isFocused = ref(false)

const isActive = computed(() => props.active || isHovered.value || isFocused.value)
</script>

<template>
  <BaseLink
    :router-link="routerLink && !active"
    :v2-link="v2Link"
    class="app-nav-menu-item h-100% flex cursor-pointer items-center flex-gap-2 text-sm text-[--theme-color-nav-text] p-block-2 p-inline-3 lt-sm:text-text-400 lt-sm:fw-500 sm:fw-600"
    :class="{
      active: isActive,
    }"
    :url="url"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
    @focus="isFocused = true"
    @blur="isFocused = false"
  >
    <DSIcon
      :icon="icon"
      size="16"
      class="text-[--theme-color-nav-text] sm:inline-flex lt-sm:text-secondary-300 lt-sm:!hidden"
    />
    <DSIcon
      :icon="isActive ? icon : iconAlt"
      size="24"
      class="text-[--theme-color-nav-text] lt-sm:inline-flex lt-sm:text-secondary-300 sm:!hidden"
    />
    <span>{{ label }}</span>
    <template v-if="badge">
      <span
        class="wh-16px flex items-center justify-center rounded-10px text-xs line-height-0 lt-sm:hidden"
        :class="isActive ? 'bg-[--theme-color-nav-background] text-[--theme-color-nav-text]' : 'bg-[--theme-color-accent] text-[--theme-color-accent-contrast]'"
      >{{ badge }}</span>
    </template>
  </BaseLink>
</template>

<style scoped lang="scss">
.active {
  @apply bg-[--theme-color-accent] rounded sm:important-text-[--theme-color-accent-contrast] lt-sm:bg-secondary-400 lt-sm:text-text-100;
  [data-ds-component='ds-icon'] {
    @apply sm:important-text-[--theme-color-accent-contrast] lt-sm:text-text-100;
  }
}
</style>
